import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("停用")

import { ref, unref } from 'vue';
import { GbDialog } from '@/components/GbDialog/Index';
import { useLocales } from '@/hooks/useLocales';
import { GetRoleDetailApi, CreateRoleApi, ModifyRoleApi } from '@/apis/basics/roles/api';
import { FormRules, ElMessage } from 'element-plus';
import { RoleBase } from '../../../../apis/basics/roles/dto';

export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales();

const show = ref<boolean>(false);
const loading = ref<boolean>(false);
const isEditor = ref<boolean>(false);

const dialogTitle = ref<string>('角色管理');

const formSchema = ref<RoleBase>({
	id: '',
	revision: '0',
	code: '',
	name: '',
	is_enabled: 'Y',
	remark: '',
	sort: 100,
});

/* 表单验证规则 */
const formRules: FormRules = {
	code: [{ required: true, message: '角色编号不能留空', trigger: 'blur' }],
	name: [{ required: true, message: '角色名称不能留空', trigger: 'blur' }],
};

const getRoleDetail = (rowId: string) => {
	loading.value = true;

	GetRoleDetailApi(rowId)
		.then((res) => {
			const { succeeded, errors, data } = res;

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				formSchema.value = Object.assign({}, data);
			}
		})
		.finally(() => {
			loading.value = false;
		});
};

/* 打开对话框 */
const showDialog = (rowId: string, editor: boolean) => {
	if (editor) {
		getRoleDetail(rowId);
	} else {
		formSchema.value = Object.assign({ is_enabled: 'Y', revision: '0', sort: 100 });
	}

	dialogTitle.value = editor ? '编辑角色' : '新增角色';

	isEditor.value = editor;

	show.value = true;
};

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	const formData = unref(formSchema);

	const api = !unref(isEditor) ? CreateRoleApi : ModifyRoleApi;

	api(formData)
		.then((res) => {
			const { succeeded, errors, data } = res;

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('保存成功');
				show.value = false;
			}
		})
		.finally(() => {
			$emits('refresh');
		});
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
    title: dialogTitle.value,
    style: {"width":"640px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: loading.value,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (show.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          size: "small",
          ref: "formRef",
          "label-width": "100px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "角色编号",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.code) = $event)),
                          type: "text",
                          placeholder: "请输入角色编号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "角色名称",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.name) = $event)),
                          type: "text",
                          placeholder: "请输入角色名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.sort) = $event)),
                          step: "100",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          rows: "4",
                          placeholder: "备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "状态",
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})